import Constant from '@/common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { approveRejectAnonymousQaTicket, editTicketData, getDetailTicketInTicketList } from '@/service/ticketService';
import { createFilterOptions } from '@material-ui/lab';
import { getProjectById } from '@/service/projectService';
import { createKibanaEditContentOperationFormList } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';

const TELEPHONE_CALL_STATUS_VALUES = Object.values(TelephoneConstant.TELEPHONE_CALL_STATUS);

export const isOpenButtonCreateTicket = (
    userDetail,
    contractType,
    ticketListType,
    projectInuseDetail
) => {
    if (
        projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER &&
        Utils.isGeneralUserWithoutGuest(userDetail)
    ) {
        return false;
    }

    if (ticketListType === Constant.MENU_SELECT_TYPE.TICKET_LIST_HELP_DESK_SIDE) {
        if (
            projectInuseDetail.type === Constant.PROJECT_TYPE.BASE ||
            projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER 
            // || Utils.isPublicOffDeskOff(projectInuseDetail)
        ) {
            return false;
        }
        
        // guest desk, all member can create ticket
        if(Utils.isProjectGuestDesk(projectInuseDetail)) {
            return true;
        }
    }

    if (ticketListType === Constant.MENU_SELECT_TYPE.TICKET_LIST_CUSTOMER_SIDE) {
        // in project base of guest corp
        if (
            projectInuseDetail.type === Constant.PROJECT_TYPE.BASE &&
            [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(contractType)
        ) {
            return false;
        }
    }

    return true;
};

export const getCreateTicketTypeDefault = (ticketListType, parentCreateTicketType) => {
    if (parentCreateTicketType) {
        return parentCreateTicketType;
    }

    if (ticketListType === Constant.TYPE_GET_TICKET_LIST.CUSTOMER) {
        return Constant.TICKET_TYPE.QA;
    } else {
        if (parentCreateTicketType) {
            return parentCreateTicketType;
        }
        return Constant.TICKET_TYPE.NOTICE;
    }
};

/**
 * onClickRejectAnonymousQaTicket
 * @param {*} ticket 
 * @param {*} argsCommon 
 * @returns 
 */
export const onClickRejectAnonymousQaTicket = (ticket, setSelectedTicket, setIsConfirmRejectTicket) => {
    if (Utils.isEmptyObject(ticket) || (!Utils.isAnonymousQAWaitingTicket(ticket) && !Utils.isAnonymousQATicketFromLiveChat(ticket))) {
        return;
    }

    setSelectedTicket(cloneDeep(ticket));
    setIsConfirmRejectTicket(true);  
}


/**
 * argsCommon
 * @param {*} argsCommon 
 */
export const onSubmitRejectAnonymousQaTicket = async (argsCommon) => {
    if (Utils.isEmptyObject(argsCommon.selectedTicket)) return;
    argsCommon.setIsLoading(true);
    
    let rejectRequestDto = {
        currentUserMail: argsCommon.userDetail?.mail,
        ticketId: argsCommon.selectedTicket?.id,
        corporationId: argsCommon.corporationId,
        ticketType: argsCommon.selectedTicket?.ticketType,
        approveFlag: Constant.APPROVE_FLAG.REJECTED,
        currentUserId: argsCommon.userDetail?.id,
    }
    let rejectTicket = await approveRejectAnonymousQaTicket(argsCommon.API, rejectRequestDto);
    if (!rejectTicket || !rejectTicket.id) {
        argsCommon.setIsOpenModalApproveRejectError(true);
        argsCommon.setIsLoading(false);
        return;
    };

    if(rejectTicket.wasUpdatedBefore){
        argsCommon.setIsLoading(false);
        argsCommon.setApprovalFlagAfterUpdated(rejectTicket.anonymousQaStatus);
        argsCommon.setSelectedTicket(rejectTicket)
        // argsCommon.setIsTicketUpdatedBefore(true)
        argsCommon.setIsOpenModalApproveRejectError(true);
        return 
    }

    // Remove work space ticket detail
    let currentPanelList = cloneDeep(argsCommon.panelList);
    let helpDeskDetailTicketPanel = currentPanelList.find(panel => panel.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL);
    if (!Utils.isEmptyObject(helpDeskDetailTicketPanel)) {
        if (!Utils.isEmptyArray(helpDeskDetailTicketPanel.tabList)) {
            let tabTicketDetail = helpDeskDetailTicketPanel.tabList.find(tab => tab.id === argsCommon.selectedTicket?.id);
            if (!Utils.isEmptyObject(tabTicketDetail)) {
                argsCommon.closePanelTab({
                    event: null,
                    panelType: helpDeskDetailTicketPanel.type,
                    panelId: helpDeskDetailTicketPanel.id,
                    tabId: tabTicketDetail.id
                });
            }
        }
    }
    
    setTimeout(() => {
        // Reload list helpdesk
        argsCommon.triggerReload(Date.now().toString());
    }, 1000);
}

export const reloadPanelRejectAnonymousTicket  =(argsCommon) =>{
    let currentPanelList = cloneDeep(argsCommon.panelList);
    let helpDeskDetailTicketPanel = currentPanelList.find(panel => panel.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL);
    if (!Utils.isEmptyObject(helpDeskDetailTicketPanel)) {
        if (!Utils.isEmptyArray(helpDeskDetailTicketPanel.tabList)) {
            let tabTicketDetail = helpDeskDetailTicketPanel.tabList.find(tab => tab.id === argsCommon.selectedTicket?.id);
            if (!Utils.isEmptyObject(tabTicketDetail)) {
                argsCommon.closePanelTab({
                    event: null,
                    panelType: helpDeskDetailTicketPanel.type,
                    panelId: helpDeskDetailTicketPanel.id,
                    tabId: tabTicketDetail.id
                });
            }
        }
    }
    
    // Reload list helpdesk
    argsCommon.triggerReload(Date.now().toString());
}

export const reloadPanelApproveAnonymousTicket = (argsCommon) => {
    argsCommon.triggerReload(Date.now().toString());

    // Reload ticket detail if opening ticket
    let currentPanelList = cloneDeep(argsCommon.panelList);
    let helpDeskDetailTicketPanelIndex = currentPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL);
    if (helpDeskDetailTicketPanelIndex !== -1) {
        let helpDeskDetailTicketPanel = currentPanelList[helpDeskDetailTicketPanelIndex];
        if (!Utils.isEmptyArray(helpDeskDetailTicketPanel.tabList)) {
            let tabTicketDetailIndex = helpDeskDetailTicketPanel.tabList.findIndex(tab => tab.id === argsCommon?.selectedTicket?.id);
            if (tabTicketDetailIndex !== -1) {
                currentPanelList[helpDeskDetailTicketPanelIndex].tabList[tabTicketDetailIndex].component.props.triggerReload = Date.now().toString();
            }
        }
    }
    argsCommon.setPanelList(currentPanelList);
}

export const onSubmitAcceptAnonymousQaTicket = async (argsCommon) => {
    argsCommon.setIsLoading(true);
    let approveRequestDto = {
        currentUserMail: argsCommon.userDetail?.mail,
        ticketId: argsCommon.selectedTicket?.id,
        corporationId: argsCommon.corporationId,
        ticketType: argsCommon.selectedTicket?.ticketType,
        approveFlag: Constant.APPROVE_FLAG.APPROVE,
        currentUserId: argsCommon.userDetail?.id,
    }
    let approveTicket = await approveRejectAnonymousQaTicket(argsCommon.API, approveRequestDto);
    let logData = createKibanaEditContentOperationFormList({
        corporationDetail: argsCommon.corporationDetail,
        projectDetail: argsCommon.selectedProject,
        userDetail: argsCommon.userDetail,
        ticketDetail: argsCommon.selectedTicket,
        publicRange: ''
    });

    let actionDetail = 'edit';
    let status = Utils.convertJSONDataToObject(argsCommon?.selectedTicket?.status)
    if(!Utils.isEmptyObject(status) && (typeof status === 'string' && status?.includes('field_'))){
        actionDetail = 'edit(changeStatus:{status})'
    }
    logData.actionDetail = actionDetail
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT_FROM_LIST,
        logKibanaData: logData
    };
    createKibanaLogAPI(argsCommon.API, param);
    if (!approveTicket || !approveTicket.id) {
        argsCommon.setIsLoading(false);
        argsCommon.setIsOpenModalApproveRejectError(true);
        return;
    };

    if(approveTicket.wasUpdatedBefore){
        argsCommon.setIsLoading(false);
        argsCommon.setApprovalFlagAfterUpdated(approveTicket.anonymousQaStatus);
        // argsCommon.setIsTicketUpdatedBefore(true)
        argsCommon.setIsOpenModalApproveRejectError(true);
        return 
    }
    // Reload list helpdesk
    argsCommon.triggerReload(Date.now().toString());

    // Reload helpdesk ticket detail if opening ticket
    updateHelpdeskTicketDetailByTicketId(argsCommon.panelList, argsCommon.setPanelList, argsCommon.selectedTicket?.id);
}

export const checkDataChangedBeforeChatNowRejectTicket = async (API, projectId, currentProject) => {

    let response = {
        status: false
    }
    if(!projectId || Utils.isEmptyObject(currentProject)) {
        return response;
    }

    let publicKnowledgeSiteSettingCurrent = Utils.convertJSONDataToObject(currentProject?.publicKnowledgeSiteSetting);
    let chatbotSettingCurrent = Utils.convertJSONDataToObject(currentProject?.chatbotSetting);

    let projectDetails = await getProjectById(API, projectId);
    if(Utils.isEmptyObject(projectDetails)) {
        return response;
    }
    let publicKnowledgeSiteSetting = Utils.convertJSONDataToObject(projectDetails?.publicKnowledgeSiteSetting);
    let chatbotSetting = Utils.convertJSONDataToObject(projectDetails?.chatbotSetting);
    if(Utils.isEmptyObject(publicKnowledgeSiteSetting) || Utils.isEmptyObject(chatbotSetting)) {
        return response;
    }

    if (
        publicKnowledgeSiteSettingCurrent?.isShowChatbot !==
            publicKnowledgeSiteSetting?.isShowChatbot ||
        chatbotSettingCurrent?.isActivateChatbot !== chatbotSetting?.isActivateChatbot
    ) {
        return response;
    }
    response.status =  true;
    return response;
}

export const onSubmitApproveAnonymousQaFromLiveChat = async (argsCommon, reloadTicketListByPanelType) => {
    let checkDataChanged = await checkDataChangedBeforeChatNowRejectTicket(argsCommon?.API, argsCommon?.currentProjectId, argsCommon?.projectDetails);
    if(!checkDataChanged.status) {
        argsCommon.setIsOpenModalReloadPage(true);
        return;
    }
    argsCommon.setIsLoading(true);
    let approveRequestDto = {
        currentUserMail: argsCommon.userDetail?.mail,
        ticketId: argsCommon.selectedTicket?.id,
        corporationId: argsCommon.corporationId,
        ticketType: argsCommon.selectedTicket?.ticketType,
        approveFlag: Constant.ANONYMOUS_TICKET_STATUS.CHAT_NOW,
        currentUserId: argsCommon.userDetail?.id,
    }

    let approveTicket = await approveRejectAnonymousQaTicket(argsCommon.API, approveRequestDto);
    
    let logData = createKibanaEditContentOperationFormList({
        corporationDetail: argsCommon.corporationDetail,
        projectDetail: argsCommon.projectDetails,
        userDetail: argsCommon.userDetail,
        ticketDetail: argsCommon.selectedTicket,
        publicRange: ''
    });

    let actionDetail = 'edit';
    let status = Utils.convertJSONDataToObject(argsCommon?.selectedTicket?.status)
    if(!Utils.isEmptyObject(status) || (typeof status === 'string' && status?.includes('field_'))){
        actionDetail = 'edit(changeStatus:{status})'
    };

    logData.actionDetail = actionDetail
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT_FROM_LIST,
        logKibanaData: logData
    };
    createKibanaLogAPI(argsCommon.API, param);
    if (!approveTicket) {
        argsCommon.setIsLoading(false);
        return;
    };

    if(approveTicket.wasUpdatedBefore){
        if(approveTicket?.anonymousQaStatus !== Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE || !approveTicket.id) {
            argsCommon.setIsLoading(false);
            argsCommon.setIsOpenModalReloadPage(true);
            return;
        }
        argsCommon.setIsLoading(false);
        argsCommon.setApprovalFlagAfterUpdated(approveTicket.anonymousQaStatus);
        argsCommon.setIsTicketUpdatedBefore(true)
        return 
    }
    // Reload list helpdesk
    argsCommon.triggerReload(Date.now().toString());

    // Reload helpdesk ticket detail if opening ticket
    updateHelpdeskTicketDetailByTicketId(argsCommon.panelList, argsCommon.setPanelList, argsCommon.selectedTicket?.id);
    
    //reload panel chat thread
    reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD});

    //reload panel list helpdesk
    reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST});

}

export const onClickApproveAnonymousQaTicket = (ticket, setSelectedTicket, setIsConfirmAcceptTicket) => {
    if (Utils.isEmptyObject(ticket) || !Utils.isAnonymousQAWaitingTicket(ticket)) {
        return;
    }
    setSelectedTicket(cloneDeep(ticket));
    setIsConfirmAcceptTicket(true); 
    return;
}

/**
 * updateHelpdeskTicketDetailByTicketId
 * @param {*} panelList 
 * @param {*} setPanelList 
 * @param {*} ticketId 
 */
 export const updateHelpdeskTicketDetailByTicketId = (panelList, setPanelList, ticketId) => {
    let currentPanelList = cloneDeep(panelList);
    let helpDeskDetailTicketPanelIndex = currentPanelList.findIndex(panel => panel.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL);
    if (helpDeskDetailTicketPanelIndex !== -1) {
        let helpDeskDetailTicketPanel = currentPanelList[helpDeskDetailTicketPanelIndex];
        if (!Utils.isEmptyArray(helpDeskDetailTicketPanel.tabList)) {
            let tabTicketDetailIndex = helpDeskDetailTicketPanel.tabList.findIndex(tab => tab.id === ticketId);
            if (tabTicketDetailIndex !== -1) {
                currentPanelList[helpDeskDetailTicketPanelIndex].tabList[tabTicketDetailIndex].component.props.triggerReload = Date.now().toString();
            }
        }
    }
    setPanelList(currentPanelList);
}


/**
 * permissionAssignTicket
 * @param {*} ticketListType 
 * @param {*} ticket 
 * @param {*} isProjectManager 
 * @returns 
 */
export const permissionAssignTicket = (ticketListType, ticket) => {
    if (
        [
            Constant.TICKET_TYPE.TASK,
            Constant.TICKET_TYPE.EMAIL,
            Constant.TICKET_TYPE.TELEPHONE
        ].includes(ticket.ticketType) &&
        ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK
    ) {
        return true;
    }
    if (ticketListType && ticketListType !== Constant.TYPE_GET_TICKET_LIST.HELPDESK) {
        return false;
    }
    if (ticket.isInternalTicket || ticket.isExternalTicket) {
        return true;
    }
    return false;
}


/**
 * filterSugguestionAssignOption
 */
 export const filterSugguestionAssignOption = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.fullName,
});


/**
 * onSelectNewAssign
 * @param {*} newAssign 
 * @param {*} ticket 
 * @param {*} argsCommon 
 * @returns 
 */
export const onSelectNewAssign = async (newAssign, argsCommon) => {
    if (!newAssign || Utils.isEmptyObject(newAssign) || !newAssign.id || !argsCommon.selectedTicket || Utils.isEmptyObject(argsCommon.selectedTicket)) return;
    let ticket = argsCommon.selectedTicket;

    if (newAssign?.id === ticket.personInChargeInfo?.id) {
        argsCommon.setAssignListPopover(null);
        argsCommon.setOpenAssignListPopoverId(null);
        return;
    }

    // Hide popover
    argsCommon.setAssignListPopover(null);
    argsCommon.setSelectedTicket({});

    argsCommon.setIsLoading(true);
    // call API
    let editAssignRequestDto = {
        currentUserMail: argsCommon.userDetail?.mail,
        ticketId: ticket?.id,
        corporationId: localStorageUtil.getAffiliationOrganization(),
        ticketType: ticket?.ticketType,
        currentUserId: argsCommon.userDetail?.id,
        newAssigneeId: newAssign.id,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_ASSIGNEE,
        currentAssigneeId: ticket.personInChargeInfo?.id,
        forceUpdate: true
    }

    let updateAssign = await editTicketData(argsCommon.API, editAssignRequestDto);
    if (updateAssign.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
        argsCommon.setIsLoading(false);
        argsCommon.setIsOpenModalReloadPage(true);
        return;
    }

    let logData = createKibanaEditContentOperationFormList({
        corporationDetail: argsCommon.corporationDetail,
        projectDetail: argsCommon.projectInuseDetail,
        userDetail: argsCommon.userDetail,
        ticketDetail: argsCommon.selectedTicket,
        publicRange: ''
    });

    let isAssigneeToChangeStatus =
        (Utils.isEmptyString(ticket.personInCharge) &&
            newAssign.id !== Constant.OPTION_UNASSIGNEE.KEY) ||
        newAssign.id === Constant.OPTION_UNASSIGNEE.KEY;

    logData.actionDetail = !Utils.isEmptyString(ticket.personInChargeInfo?.id) && !isAssigneeToChangeStatus
        ? 'edit'
        : ticket.formDefinition === Constant.FORM_DEFINITION.SYSTEM && ticket.ticketType !== Constant.TICKET_TYPE.EMAIL
            ? 'edit'
            : 'edit(changeStatus:{status})';
    
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT_FROM_LIST,
        logKibanaData: logData
    };
    createKibanaLogAPI(argsCommon.API, param);

    if (!updateAssign) {
        argsCommon.setIsLoading(false);
        return;
    }

    if(updateAssign.wasUpdatedBefore) {
        argsCommon.setIsLoading(false);
        argsCommon.setConfirmForceEditTicket({
            method: Constant.UPDATE_TICKET_METHOD.UPDATE_ASSIGNEE,
            requestDto: { ...editAssignRequestDto, forceUpdate: true }
        });
        return;
    }

    setTimeout(() => {
        // Update ticket detail
        updateHelpdeskTicketDetailByTicketId(argsCommon.panelList, argsCommon.setPanelList, ticket?.id);

        // Reload list ticket
        argsCommon.triggerReload(Date.now().toString());
    }, 1000);
}


/**
 * confirmForceEditTicket
 * @param {*} argsCommon 
 * @returns 
 */
export const confirmForceEditTicket = async (argsCommon, method) => {
    if (!argsCommon.confirmForceEditTicket || !argsCommon.confirmForceEditTicket.requestDto || Utils.isEmptyObject(argsCommon.confirmForceEditTicket.requestDto)) return;

    argsCommon.setIsLoading(true);
    // call API
    let editTicketRequestDto = cloneDeep(argsCommon.confirmForceEditTicket.requestDto);
    editTicketRequestDto.forceUpdate = true;
    if (method) {
        editTicketRequestDto.updateMethod = method;
    }
    
    let updateAssign = await editTicketData(argsCommon.API, editTicketRequestDto);
    if (!updateAssign) {
        argsCommon.setIsLoading(false);
        return;
    }

    // Hide popover
    argsCommon.setAssignListPopover(null);

    // Update ticket detail
    updateHelpdeskTicketDetailByTicketId(argsCommon.panelList, argsCommon.setPanelList, editTicketRequestDto.ticketId);

    // Reload list ticket
    argsCommon.triggerReload(Date.now().toString());
}

/**
 * getAssignTicketData
 * get permission and data to assign
 * @param {*} item 
 * @param {*} argsCommon 
 * @returns 
 */
export const getAssignTicketData = (item, argsCommon) => {
    let hasAssignee = false;
    let assigneeAvatar = '';
    let assigneeIcon = '';
    let assigneeFullName = '';
    let canEditAssignee = true;
    let canHasAssignee = true;
    let permissionAssign = permissionAssignTicket(argsCommon.ticketListType, item);
    const ticketMetaData = Utils.convertJSONDataToObject(item?.metaData);

    if (ticketMetaData?.telephoneType === Constant.TICKET_PROPERTY.TRAINING) {
        return {
            hasAssignee: false,
            assigneeAvatar: '',
            assigneeIcon: '',
            assigneeFullName: '',
            canEditAssignee: false,
            canHasAssignee: false,
            permissionAssign: false,
        };
    }

    if (item.personInChargeInfo && !Utils.isEmptyObject(item.personInChargeInfo) && item.personInChargeInfo.id) {
        hasAssignee = true;
        if (item.personInChargeInfo.fullName) {
            assigneeFullName = `${item.personInChargeInfo.fullName}`;
        } else {
            assigneeFullName = `${item.personInChargeInfo.lastName} ${item.personInChargeInfo.firstName}`;
            if (item.personInChargeInfo.active === Constant.ACTIVE_FLAG.DELETED) {
                assigneeFullName = `${assigneeFullName} (${Constant.SUFFIX_TEXT.DELETED_USER})`;
            }
        }
        if (item.personInChargeInfo.avatar) {
            assigneeAvatar = item.personInChargeInfo.avatar;
        } else {
            assigneeIcon = item.personInChargeInfo.shortName;
        }
        if (!item.personInChargeInfo.picFieldActive) canHasAssignee = false
    }

    if (argsCommon.isCustomerListTicket) {
        canEditAssignee = false;
    } else if (argsCommon.isHelpdeskListTicket) {
        canEditAssignee = permissionAssign; // permisstion Edit
    }

    if (
        ![
            Constant.TICKET_TYPE.QA,
            Constant.TICKET_TYPE.INTERNAL_QA,
            Constant.TICKET_TYPE.EXTERNAL_QA,
            Constant.TICKET_TYPE.DELEGATE,
            Constant.TICKET_TYPE.ESCALATION,
            Constant.TICKET_TYPE.BROADCAST_PARENT,
            Constant.TICKET_TYPE.BROADCAST_CHILD,
            Constant.TICKET_TYPE.TASK,
            Constant.TICKET_TYPE.EMAIL,
            Constant.TICKET_TYPE.TELEPHONE
        ].includes(item.ticketType) ||
        Utils.isAnonymousQAWaitingTicket(item) ||
        Utils.isAnonymousQARejectTicket(item) ||
        item.public === Constant.TICKET_PUBLIC.DRAFT
    ) {
        hasAssignee = false;
        canEditAssignee = false;
        canHasAssignee = false;
    }

    if (item.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED) {
        canEditAssignee = false;
    }

    return {
        hasAssignee,
        assigneeAvatar,
        assigneeIcon,
        assigneeFullName,
        canEditAssignee,
        canHasAssignee,
        permissionAssign,
    };
}


/**
 * getAssignList
 * getAssignList to assign
 * @param {*} ticket 
 * @param {*} argsCommon 
 * @returns 
 */
export const getAssignList = (projectUserList, userDetail) => {
    if (!Utils.isEmptyArray(projectUserList)) {
        projectUserList = projectUserList.filter(user => user.active === Constant.ACTIVE_FLAG.ACTIVE);
    }
    let assignList = addUserMe([...projectUserList], userDetail, true);
    return addOptionBlank(assignList);
}

const addUserMe = (assignList, userDetail, isMe) => {
    if (Utils.isEmptyArray(assignList)) {
        return [];
    }

    if (isMe) {
        let resultUser = assignList.find(user => {
            return user.id === userDetail.id
        })

        if (!Utils.isEmptyObject(resultUser)) {
            let userMe = {...resultUser};
            userMe.fullName = Constant.OPTION_ASSIGNEE_ME;
            assignList.unshift(userMe);
        }
    }

    return assignList;
}

const addOptionBlank = (assignList) => {
    let optionBlank = {
        id: Constant.OPTION_UNASSIGNEE.KEY,
        fullName: Constant.OPTION_UNASSIGNEE.TEXT,      
    }
    assignList.unshift(optionBlank);
    return assignList;
}

/**
 * getCurrentStatusData
 * @param {*} ticket 
 * @param {*} argsCommon field_c3bd78e6-11e1-46c8-ac7a-05313d275d14
 * @returns 
 */
export const getCurrentStatusData = (ticket, fieldListInState) => {
    let initData = {
        currentStatusItemData: {},
        statusItemList: []
    }

    if (!ticket.statusDetail || !ticket.statusDetail?.currentStatus || !ticket.statusDetail?.currentStatusField) return initData;
    let currentStatusItem = ticket.statusDetail?.currentStatus;

    let currentStatusItemData = {};
    if (!Utils.isEmptyArray(ticket.statusItemList)) {
        let newStatusItemList = Utils.removeDuplicateInArrayById(ticket.statusItemList);
        currentStatusItemData = ticket.statusItemList.find(item => item.id === currentStatusItem);
        return { currentStatusItemData, statusItemList: newStatusItemList };
    }

    return initData;
}

/**
 * getCurrentTelephoneStatusData
 * Normalize telephone status data to a stable shape for list UI.
 * @param {*} ticket
 * @returns {{currentStatus: string, currentStatusField: string, statusItemList: Array}}
 */
export const getCurrentTelephoneStatusData = ticket => {
    const initData = {
        currentStatus: '',
        currentStatusField: '',
        statusItemList: []
    };

    if (!ticket || ticket.ticketType !== Constant.TICKET_TYPE.TELEPHONE) {
        return initData;
    }

    const statusItemList = Utils.isEmptyArray(ticket?.telephoneStatusItemList)
        ? []
        : Utils.removeDuplicateInArrayById(ticket.telephoneStatusItemList);
    let currentStatus = ticket?.telephoneStatusDetail?.currentStatus || '';
    let currentStatusField = ticket?.telephoneStatusDetail?.currentStatusField || '';

    const findItemById = statusId => {
        if (!statusId || Utils.isEmptyArray(statusItemList)) {
            return null;
        }
        return statusItemList.find(item => item?.id === statusId) || null;
    };

    const parseStatusToObject = statusValue => {
        if (!statusValue) {
            return null;
        }
        if (typeof statusValue === 'object') {
            return statusValue;
        }
        if (typeof statusValue !== 'string') {
            return null;
        }

        try {
            const isJavaToStringFormat =
                statusValue.includes('=') &&
                statusValue.startsWith('{') &&
                statusValue.endsWith('}');
            if (isJavaToStringFormat) {
                const jsonString = statusValue
                    .replace(/\{|\}/g, '')
                    .split(',')
                    .map(pair => {
                        const [key, value] = pair.split('=').map(s => s.trim());
                        return `"${key}":"${value}"`;
                    })
                    .join(',');
                return JSON.parse(`{${jsonString}}`);
            }
            return Utils.convertJSONDataToObject(statusValue);
        } catch (error) {
            return null;
        }
    };

    if (currentStatus) {
        const currentStatusItem = findItemById(currentStatus);
        if (currentStatusItem?.sysField) {
            currentStatusField = currentStatusItem.sysField;
        }
    }

    if (!TELEPHONE_CALL_STATUS_VALUES.includes(currentStatusField) && ticket?.telephoneStatus) {
        const telephoneStatusObject = parseStatusToObject(ticket.telephoneStatus);

        if (
            telephoneStatusObject &&
            typeof telephoneStatusObject === 'object' &&
            !Array.isArray(telephoneStatusObject)
        ) {
            if (
                telephoneStatusObject?.workflow ===
                    TelephoneConstant.TELEPHONE.SYSTEM_FIELD.CALL_STATUS &&
                telephoneStatusObject?.status
            ) {
                const currentStatusItem = findItemById(telephoneStatusObject.status);
                if (currentStatusItem?.sysField) {
                    currentStatusField = currentStatusItem.sysField;
                    currentStatus = currentStatusItem.id;
                } else {
                    currentStatusField = telephoneStatusObject.status;
                    currentStatus = telephoneStatusObject.status;
                }
            } else {
                const statusIdList = Object.values(telephoneStatusObject);
                const statusId = !Utils.isEmptyArray(statusIdList) ? statusIdList[0] : '';
                if (statusId) {
                    const currentStatusItem = findItemById(statusId);
                    if (currentStatusItem?.sysField) {
                        currentStatusField = currentStatusItem.sysField;
                        currentStatus = currentStatusItem.id;
                    } else {
                        currentStatusField = statusId;
                        currentStatus = statusId;
                    }
                }
            }
        }
    }

    if (!TELEPHONE_CALL_STATUS_VALUES.includes(currentStatusField)) {
        currentStatusField = '';
    }

    return {
        currentStatus,
        currentStatusField,
        statusItemList
    };
};


/**
 * permissionEditTicketStatus
 * @param {*} ticketListType 
 * @param {*} ticket 
 */
export const permissionEditTicketStatus = (ticketListType, ticket) => {
    if ([Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(ticket.ticketType) && ticketListType === Constant.TYPE_GET_TICKET_LIST.HELPDESK) {
        return true;
    }

    if (Utils.isAnonymousQAEndLiveChatTicket(ticket)) {
        return false;
    }

    if (ticketListType && ticketListType !== Constant.TYPE_GET_TICKET_LIST.HELPDESK) {
        return false;
    }

    if (ticket.isInternalTicket || ticket.isExternalTicket) {
        return true;
    }
    return false;
}


/**
 * onClickEditTicketStatus
 * @param {*} event 
 * @param {*} ticket 
 * @param {*} currentStatusItemStructure 
 * @param {*} argsCommon 
 * @returns 
 */
export const onClickEditTicketStatus = (event, ticket, currentStatusItemStructure, argsCommon, isDeletedCorporationOrigin) => {
    if (currentStatusItemStructure.no === Constant.STATUS_NO.WAITING || ticket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED || !permissionEditTicketStatus(argsCommon.ticketListType, ticket) || isDeletedCorporationOrigin) {
        return;
    }

    if (
        ticket?.ticketType === Constant.TICKET_TYPE.EMAIL &&
        ((currentStatusItemStructure.no === Constant.STATUS_NO.DONE &&
            !Utils.isPublicDesk(argsCommon?.projectInuseDetail)) ||
            (!Utils.isEnableCreateEmailTicketMode(
                argsCommon?.corporationDetail,
                argsCommon?.projectInuseDetail
            ) &&
                currentStatusItemStructure?.no === Constant.STATUS_NO.DONE))
    )
        return false;

    argsCommon.setTicketStatusListPopover(event.currentTarget);
    argsCommon.setOpenTicketStatusListPopoverId(ticket.id);
    argsCommon.setSelectedTicket(cloneDeep(ticket));
}

/**
 * canTicketHasStatus
 * @param {*} ticket 
 * @returns 
 */
export const canTicketHasStatus = (ticket, isHelpDeskTicketList) => {
    if (
        !ticket ||
        ![
            Constant.TICKET_TYPE.QA,
            Constant.TICKET_TYPE.INTERNAL_QA,
            Constant.TICKET_TYPE.EXTERNAL_QA,
            Constant.TICKET_TYPE.DELEGATE,
            Constant.TICKET_TYPE.ESCALATION,
            Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK,
            Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER,
            Constant.TICKET_TYPE.TASK,
            Constant.TICKET_TYPE.EMAIL,
            Constant.TICKET_TYPE.TELEPHONE
        ].includes(ticket.ticketType) ||
        (Utils.isAnonymousQAWaitingTicket(ticket) && isHelpDeskTicketList) ||
        Utils.isAnonymousQARejectTicket(ticket) ||
        ticket.public === Constant.TICKET_PUBLIC.DRAFT
    ) {
        return false;
    }
    return true;
};

export const canTicketHasPIC = (ticket) => {
    if (
        !ticket ||
        ![
            Constant.TICKET_TYPE.QA,
            Constant.TICKET_TYPE.INTERNAL_QA,
            Constant.TICKET_TYPE.EXTERNAL_QA,
            Constant.TICKET_TYPE.DELEGATE,
            Constant.TICKET_TYPE.ESCALATION, 
            Constant.TICKET_TYPE.NOTICE,
            Constant.TICKET_TYPE.BROADCAST_PARENT,
            Constant.TICKET_TYPE.BROADCAST_CHILD,
            Constant.TICKET_TYPE.TASK,
            Constant.TICKET_TYPE.EMAIL,
            Constant.TICKET_TYPE.TELEPHONE,
        ].includes(ticket.ticketType) ||
        // Utils.isAnonymousQAWaitingTicket(ticket) ||
        Utils.isAnonymousQARejectTicket(ticket) ||
        ticket.public === Constant.TICKET_PUBLIC.DRAFT
    ) {
        return false;
    }
    return true;
};



/**
 * changeTicketStatus
 * @param {*} newStatus 
 * @param {*} ticket 
 * @param {*} argsCommon 
 * @returns 
 */
export const changeTicketStatus = async (newStatus, argsCommon, statusNo, reloadTabByPanelTypeAndTabId, setIsOpenModalReloadPage) => {
    if (!newStatus || !argsCommon.selectedTicket || Utils.isEmptyObject(argsCommon.selectedTicket)) return;
    let ticket = argsCommon.selectedTicket;

    if (newStatus === ticket.statusDetail?.currentStatus) {
        return;
    }

    // Hide popover
    argsCommon.setTicketStatusListPopover(null);
    argsCommon.setSelectedTicket({});

    argsCommon.setIsLoading(true);
    // call API
    let editStatusRequestDto = {
        currentUserMail: argsCommon.userDetail?.mail,
        ticketId: ticket?.id,
        corporationId: localStorageUtil.getAffiliationOrganization(),
        ticketType: ticket?.ticketType,
        currentUserId: argsCommon.userDetail?.id,
        newStatus: newStatus,
        updateMethod: Constant.UPDATE_TICKET_METHOD.UPDATE_STATUS,
        currentStatus: ticket.statusDetail?.currentStatus,
        forceUpdate: false
    }

    let updateStatusResponse = await editTicketData(argsCommon.API, editStatusRequestDto);
    if (!updateStatusResponse) {
        argsCommon.setIsLoading(false);
        return;
    }

    if(updateStatusResponse.wasUpdatedBefore) {
        argsCommon.setIsLoading(false);
        if (updateStatusResponse.errorCode === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR && setIsOpenModalReloadPage) {
            setIsOpenModalReloadPage(true);
            return;
        }
        argsCommon.setConfirmForceEditTicket({
            method: Constant.UPDATE_TICKET_METHOD.UPDATE_STATUS,
            requestDto: { ...editStatusRequestDto, forceUpdate: true }
        });
        return;
    }

    let logData = createKibanaEditContentOperationFormList({
        corporationDetail: argsCommon.corporationDetail,
        projectDetail: argsCommon.projectInuseDetail,
        userDetail: argsCommon.userDetail,
        ticketDetail: argsCommon.selectedTicket,
        publicRange: ''
    });
    logData.actionDetail = 'edit(changeStatus:{status})';

    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.EDIT_FROM_LIST,
        logKibanaData: logData
    };
    createKibanaLogAPI(argsCommon.API, param);
    // Update ticketList state

    // Update ticket detail
    updateHelpdeskTicketDetailByTicketId(argsCommon.panelList, argsCommon.setPanelList, ticket?.id);

    // Update ticket list for reload new status
    let newTicketList = cloneDeep(argsCommon.ticketList);
    let currentTicketIndex = Utils.findIndexInArrayById(updateStatusResponse.id, newTicketList);
    if (currentTicketIndex > -1 && updateStatusResponse.updatedAt) {
        newTicketList[currentTicketIndex].updatedAt = updateStatusResponse.updatedAt;
    }
    argsCommon.setTicketList(newTicketList);

    // Reload list ticket
    argsCommon.triggerReload(Date.now().toString());
    
    // Reload chatthread if ticket is end live chat
    if (Utils.isAnonymousQATicketFromLiveChat(ticket) && statusNo === Constant.STATUS_NO.DONE && reloadTabByPanelTypeAndTabId) {
        reloadTabByPanelTypeAndTabId({
            panelType: Constant.PANEL_TYPE.HELPDESK_CHATTHREAD,
            id: ticket.id
        });
    }
}


/**
 * onClickChangeTicketAssign
 * @param {*} event 
 * @param {*} ticket 
 * @param {*} argsCommon 
 * @returns 
 */
export const onClickChangeTicketAssign = (event, ticket, argsCommon, isDeletedCorporationOrigin) => {
    if (!event || !ticket || Utils.isEmptyObject(ticket) || !Utils.isEmptyString(ticket.deletedAt) || isDeletedCorporationOrigin || Utils.isAnonymousQAEndLiveChatTicket(ticket)) {
        return
    };

    let ticketAssignData = getAssignTicketData(ticket, argsCommon);

    if (!ticketAssignData || !ticketAssignData.canEditAssignee || !ticketAssignData.canHasAssignee || !ticketAssignData.permissionAssign) {
        return
    };
    argsCommon.setSelectedTicket(cloneDeep(ticket));
    argsCommon.setAssignListPopover(event.currentTarget);
    argsCommon.setOpenAssignListPopoverId(ticket.id);
}

export const getTitle = (settingTitle) =>{
    let title = '';
    settingTitle?.forEach(element => {
        if (!element.isBreak) {
            title = title +element.text
        }
    })
    return title
}


export const getDetailTicketInList = async (
    API,
    ticketId,
    ticketListType,
    corporationId,
    projectId,
    userId,
) => {
    let paramsGetDetail = {
        ticketId,
        ticketListType,
        corporationId,
        projectId,
        userId,
    };

    return getDetailTicketInTicketList(API, paramsGetDetail);
};


/**
 * isDisplayMakeCallButton
 * @param {*} corporationDetail 
 * @returns 
 */
export const isDisplayMakeCallButton = corporationDetail => {
    if (Utils.isEmptyObject(corporationDetail)) return false;

    return ![
        Constant.CORPORATION_CONTRACT_TYPE.GUEST,
        Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
    ].includes(corporationDetail.contractType);
};
